module.exports = __webpack_public_path__ + "img/introduction2.663dfdca.png";